import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import {
    provideRouter,
    withComponentInputBinding,
    withInMemoryScrolling,
    withRouterConfig,
    InMemoryScrollingOptions,
} from '@angular/router';
import {
    provideHttpClient,
    withInterceptors,
    withInterceptorsFromDi,
    HTTP_INTERCEPTORS,
    HttpClient,
} from '@angular/common/http';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { CustomAura, provideAuth0Module } from '@core/config';
import { provideTranslateModule } from '@core/i18n';
import { BrowserModule } from '@angular/platform-browser';
import { globalHttpInterceptor } from './_core/interceptors';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
};

export const appConfig: ApplicationConfig = {
    providers: [
        MessageService,
        ConfirmationService,
        BrowserModule,
        BrowserAnimationsModule,

        provideZoneChangeDetection({ eventCoalescing: true }),
        provideTranslateModule(),
        provideAnimationsAsync(),
        provideAuth0Module(),

        providePrimeNG({
            theme: {
                preset: CustomAura,
                options: {
                    darkModeSelector: '.dark-mode',
                },
            },
        }),

        provideHttpClient(withInterceptors([globalHttpInterceptor]), withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },

        provideRouter(
            routes,
            withInMemoryScrolling(scrollConfig),
            withComponentInputBinding(),
            withRouterConfig({ paramsInheritanceStrategy: 'always' })
        ),
    ],
};
